import React from 'react'
import { Countries } from '../data/Country';

function EducationalBackground({educationalBgInfo, setEducationalBgInfo, schoolCount, setSchoolCount, 
  scholarshipCount, setScholarshipCount, fellowshipCount, setFellowshipCount, researchGrantCount, setResearchGrantCount,
  nationalAwardCount, setNationalAwardCount, internationalAwardCount, setInternationalAwardCount}) {
  const handleChange = (e) =>{
    setEducationalBgInfo({
        ...educationalBgInfo, [e.target.name] : e.target.value
    });
  }

  return (
    <div className='flex flex-col box-border gap-4'>
      <div className='mb-3'>
        <h1 className='text-custom-blue font-bold text-2xl lg:text-3xl'>Educational background</h1>
      </div>
      <div className='flex flex-col box-border gap-4'>
      <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Educational Institutions Attended</p>
      <p className='text-base text-custom-brown'>Chronologically arranged from the earliest to latest</p>
        {
          Array.apply(null, {length: schoolCount}).map((e, i)=>(
            <div key={i} className='space-y-4'>
              <div className='flex flex-col gap-1'>
                <label className='text-custom-brown text-base' htmlFor={`school_of_study${i+1}`}>School Name</label>
                <input className='border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`school_of_study${i+1}`} id={`school_of_study${i+1}`} onChange={handleChange} value={educationalBgInfo[`school_of_study${i+1}`]} autoComplete='school' enterKeyHint='next' required/>
              </div>
              <div className='flex flex-row gap-2'>
                <div className='flex flex-col gap-1 sm:w-[49%] w-[49%] box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`school_of_study_city${i+1}`}>City</label>
                  <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`school_of_study_city${i+1}`} id={`school_of_study_city${i+1}`} onChange={handleChange} value={educationalBgInfo[`school_of_study_city${i+1}`]} autoComplete='city' enterKeyHint='next' required/>
                </div>
                <div className='flex flex-col gap-1 sm:w-[49%] w-[49%] box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`school_of_study_country${i+1}`}>Country</label>
                  {/* <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`school_of_study_country${i+1}`} id={`school_of_study_country${i+1}`} onChange={handleChange} value={educationalBgInfo[`school_of_study_country${i+1}`]} autoComplete='state' enterKeyHint='next' required/> */}
                  <select className='border cursor-pointer border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' name={`school_of_study_country${i+1}`} id={`school_of_study_country${i+1}`} onChange={handleChange} value={educationalBgInfo[`school_of_study_country${i+1}`]} required>
                    <option className='hover:bg-custom-blue hover:text-white cursor-pointer' value="">-Select Country-</option>
                        {Countries.map((country, i) => (
                            <option key={i} value={country}>{country}</option>
                        )
                        )}
                    </select>
                </div>
              </div>
              <div className='flex flex-col sm:flex-row gap-4 sm:gap-2'>
                <div className='flex flex-col gap-1 sm:w-[49%] box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`school_degree${i+1}`}>Academic Qualification</label>
                  <select className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' name={`school_degree${i+1}`} id={`school_degree${i+1}`} onChange={handleChange} value={educationalBgInfo[`school_degree${i+1}`]} required>
                    <option className='hover:bg-custom-blue hover:text-white' value="">-Select Qualification-</option>
                    <option className='hover:bg-custom-blue hover:text-white' value="OND">OND</option>
                    <option className='hover:bg-custom-blue hover:text-white' value="HND">HND</option>
                    <option className='hover:bg-custom-blue hover:text-white' value="B.Sc.">B.Sc.</option>
                    <option className='hover:bg-custom-blue hover:text-white' value="M.Sc.">M.Sc.</option>
                    <option className='hover:bg-custom-blue hover:text-white' value="M.Phil.">M.Phil.</option>
                    <option className='hover:bg-custom-blue hover:text-white' value="Ph.d.">Ph.D.</option>
                  </select>
                </div>
                <div className='flex flex-col gap-1 sm:w-[49%] box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`field_of_Study${i+1}`}>Field of Study</label>
                  <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 pb-2.5 bg-transparent' type='text' name={`field_of_Study${i+1}`} id={`field_of_Study${i+1}`} onChange={handleChange} value={educationalBgInfo[`field_of_Study${i+1}`]} enterKeyHint='next' required/>
                </div>
              </div>
              <div className='flex flex-row gap-2'>
                <div className='flex flex-col gap-1 w-[49%] box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`school_start_year${i+1}`}>Start Year</label>
                  <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 h-[42px] bg-transparent' type='month' name={`school_start_year${i+1}`} id={`school_start_year${i+1}`} onChange={handleChange} value={educationalBgInfo[`school_start_year${i+1}`]} required/>
                </div>
                <div className='flex flex-col gap-1 w-[49%] box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`school_end_year${i+1}`}>End Year</label>
                  <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 h-[42px] bg-transparent' type='month' name={`school_end_year${i+1}`} id={`school_end_year${i+1}`} onChange={handleChange} value={educationalBgInfo[`school_end_year${i+1}`]} required/>
                </div>
              </div>
            </div>
          ))
        }
        <div className='flex gap-5 justify-end'>
          { 
            schoolCount>1 ? 
            <button type='button' onClick={()=>{setSchoolCount(schoolCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                Remove Last
            </button> : null
          }
          <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setSchoolCount(schoolCount+1)}>
                  Add More
          </button>
        </div>
        <div className=' flex flex-col gap-4'>
          <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Scholarships</p>
          <div className='flex flex-col gap-3 box-border'>
            {
              Array.apply(null, {length: scholarshipCount}).map((e, i)=>(
                <div key={i} className='flex flex-col gap-1 box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`Scholarship${i+1}`}>Scholarship {i+1}</label>
                  <input className='border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`scholarship${i+1}`} id={`scholarship${i+1}`} onChange={handleChange} value={educationalBgInfo[`scholarship${i+1}`]}/>
                </div>
              ))
            }
          </div>
          <div className='flex gap-5 justify-end'>
            { 
              scholarshipCount>1 ? 
              <button type='button' onClick={()=>{setScholarshipCount(scholarshipCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                  Remove Last
              </button> : null
            }
            <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setScholarshipCount(scholarshipCount+1)}>
                    Add More
            </button>
          </div>
        </div>
        <div className='flex flex-col gap-4'>
          <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Fellowship</p>
          <div className='flex flex-col gap-3 box-border'>
            {
              Array.apply(null, {length: fellowshipCount}).map((e, i)=>(
                <div key={i} className='flex flex-col gap-1 box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`fellowship${i+1}`}>Fellowship {i+1}</label>
                  <input className='border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`fellowship${i+1}`} id={`fellowship${i+1}`} onChange={handleChange} value={educationalBgInfo[`fellowship${i+1}`]}/>
                </div>
              ))
            }
          </div>
          <div className='flex justify-end'>
            { 
              fellowshipCount>1 ? 
              <button type='button' onClick={()=>{setFellowshipCount(fellowshipCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                  Remove Last
              </button> : null
            }
            <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setFellowshipCount(fellowshipCount+1)}>
                    Add More
            </button>
          </div>
        </div>
        <div className='flex flex-col gap-4'>
          <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Research Grant</p>
          <div className='flex flex-col gap-3 box-border'>  
            {
              Array.apply(null, {length: researchGrantCount}).map((e, i)=>(
                <div key={i} className='flex flex-col gap-1 box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`research_grant${i+1}`}>Research Grant {i+1}</label>
                  <input className='border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`research_grant${i+1}`} id={`research_grant${i+1}`} onChange={handleChange} value={educationalBgInfo[`research_grant${i+1}`]}/>
                </div>
              ))
            }
          </div>
          <div className='flex gap-5 justify-end'>
            { 
              researchGrantCount>1 ? 
              <button type='button' onClick={()=>{setResearchGrantCount(researchGrantCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                  Remove Last
              </button> : null
            }
            <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setResearchGrantCount(researchGrantCount+1)}>
                    Add More
            </button>
          </div>
        </div>
        <div className='flex flex-col gap-4'>
          <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>National Awards</p>
          <div className='flex flex-col gap-3 box-border'>
            {
              Array.apply(null, {length: nationalAwardCount}).map((e, i)=>(
                <div key={i} className='flex flex-col gap-1 box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`national_award${i+1}`}>National Award {i+1}</label>
                  <input className='border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`national_award${i+1}`} id={`national_award${i+1}`} onChange={handleChange} value={educationalBgInfo[`national_award${i+1}`]}/>
                </div>
              ))
            }
          </div>
          <div className='flex gap-5 justify-end'>
            {
              nationalAwardCount>1 ? 
              <button type='button' onClick={()=>{setNationalAwardCount(nationalAwardCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                  Remove Last
              </button> : null
            }
            <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setNationalAwardCount(nationalAwardCount+1)}>
                    Add More
            </button>
          </div>
        </div>
        <div className='flex flex-col gap-4'>
          <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>International Awards</p>
          <div className='flex flex-col gap-3 box-border'>
            {
              Array.apply(null, {length: internationalAwardCount}).map((e, i)=>(
                <div key={i} className='flex flex-col gap-1 box-border'>
                  <label className='text-custom-brown text-base' htmlFor={`international_award${i+1}`}>International Award {i+1}</label>
                  <input className='border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`international_award${i+1}`} id={`international_award${i+1}`} onChange={handleChange} value={educationalBgInfo[`international_award${i+1}`]}/>
                </div>
              ))
            }
          </div>
          <div className='flex justify-end'>
            { 
              internationalAwardCount>1 ? 
              <button type='button' onClick={()=>{setInternationalAwardCount(internationalAwardCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                  Remove Last
              </button> : null
            }
            <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setInternationalAwardCount(internationalAwardCount+1)}>
                    Add More
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EducationalBackground